import React from 'react'

export default function PaymentForm() {
  return (
    <>
      <div className="max-w-xl mx-auto p-3 mt-10">
  <div className="bg-gray-800 rounded-lg p-3 shadow-lg">
    <h2 className="text-2xl font-bold mb-6">Payez avec votre carte de crédit</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
      <div>
        <label className="block text-sm mb-2">Nom complet </label>
        <input type="text" defaultValue="Bonnie Green" className="w-full px-4 py-2 bg-gray-700 rounded border border-gray-600 focus:outline-none" />
      </div>
      <div>
        <label className="block text-sm mb-2">Numéro de carte</label>
        <input type="text" placeholder="xxxx-xxxx-xxxx-xxxx" className="w-full px-4 py-2 bg-gray-700 rounded border border-gray-600 focus:outline-none" />
      </div>
      <div>
        <label className="block text-sm mb-2">Expiration de la carte*</label>
        <input type="text" placeholder="MM/YY" className="w-full px-4 py-2 bg-gray-700 rounded border border-gray-600 focus:outline-none" />
      </div>
      <div>
        <label className="block text-sm mb-2">CVV*</label>
        <input type="password" placeholder="•••" className="w-full px-4 py-2 bg-gray-700 rounded border border-gray-600 focus:outline-none" />
      </div>
    </div>
    <div className="flex items-center  justify-center gap-4 mb-6">
      <button className="bg-white text-black px-6 py-2 w-full rounded  hover:bg-gray-300">Google Pay</button>
      <button className="bg-yellow-400 text-black w-full px-6 py-2 rounded hover:bg-yellow-300  flex items-center gap-2">
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M22 4H2v16h20V4z" fill="none" />
          <path d="M13 15l5-3-5-3v6z" />
        </svg>
        PayPal
      </button>
    </div>
    <div className="bg-gray-700 p-4 rounded mb-4">
      <div className="flex justify-between mb-1">
        <span>Original price</span>
        <span className="font-semibold">$6,592.00</span>
      </div>
      <div className="flex justify-between mb-1 text-green-400">
        <span>Savings</span>
        <span>-$299.00</span>
      </div>
      <div className="flex justify-between mb-1">
        <span>Store Pickup</span>
        <span>$99</span>
      </div>
      <div className="flex justify-between mb-1">
        <span>Tax</span>
        <span>$799</span>
      </div>
      <div className="flex justify-between text-lg font-bold border-t border-gray-600 pt-2 mt-2">
        <span>Total</span>
        <span>$7,191.00</span>
      </div>
    </div>
    <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded font-semibold text-lg">
      Pay now
    </button>
    
  </div>
</div>

    </>
  )
}
